import {
    Box,
    Image,
    Modal,
    ModalBody,
    ModalContent,
    ModalOverlay,
    Stack,
} from "@chakra-ui/react";
import React from "react";
import Colors from "../../../assets/colors/Colors";
import warnignIcon from "../../../assets/images/Ellipse2.svg";
import email from "../../../assets/images/email.svg";
import {
    GrubAlert,
    GrubErrorMessage,
    GrubFormButton,
    GrubInput,
    GrubProgress,
    GrubTitleText,
} from "../../../components/index";
import { WithRouter } from "../../../navigators/WithRouter";
import BackIconButton from "../components/BackIconButton";
import { useForgotPassword } from "../hooks/useForgotPassword";
import * as Constants from "../../../constants/Constants";
const ForgotPassword = (props) => {
    const {
        handleKeyDown,
        formik,
        isFocused,
        emailRef,
        loading,
        serverResponse,
        keyboardOpen,
    } = useForgotPassword(props);
    return (
        <Modal
            isOpen={props.isOpen}
            size="sm"
            isCentered={!keyboardOpen}
            closeOnEsc={false}
            closeOnOverlayClick={false}
        >
            <ModalOverlay />
            <ModalContent borderRadius="0.63rem">
                {loading && <GrubProgress />}
                <ModalBody
                    pl={{ base: "2.56rem", md: "2.56rem" }}
                    pr={{ base: "2.56rem", md: "2.56rem" }}
                    pb={{ base: "4.13rem", md: "4.13rem" }}
                    pt={{ base: "1.88rem", md: "1.88rem" }}
                >
                    <BackIconButton
                        iconButton={true}
                        onClick={(e) => {
                            e.preventDefault();
                            props.handleBackButton();
                        }}
                    />
                    <GrubTitleText
                        isLabelText={true}
                        color={Colors.posTextInfo}
                        name={"Forgot Password"}
                    />
                    <Stack spacing={2} mt={{ base: "1.5rem", md: "1.5rem" }}>
                        <GrubInput
                            id="email"
                            placeholder={"Email Address"}
                            autoFocus={isFocused}
                            handleInputChange={formik.handleChange}
                            inputValue={formik.values.email || ""}
                            handleBlur={(e) => {
                                setTimeout(() => {
                                if (emailRef.current) {
                                    formik.setFieldValue(
                                        "email",
                                        formik.values.email.trim()
                                    );
                                    formik.handleBlur(e);
                                    }
                                }, Constants.TIMEOUT_DELAY);
                            }}
                            width={"18.63rem"}
                            posInputGroup={true}
                            darkPlaceholder={true}
                            onKeyDown={handleKeyDown}
                            background={Colors.posviewbgcolor}
                            inputType={"text"}
                            inputError={
                                formik.touched.email && formik.errors.email
                            }
                        >
                            <Image src={email} width={"0.99rem"} />
                        </GrubInput>
                        {formik.touched.email && formik.errors.email && (
                            <GrubAlert
                                width={"100%"}
                                alertStatus={"error"}
                                alertTitle={""}
                                image={warnignIcon}
                                bg={Colors.errorsign}
                                color={Colors.orangeButton}
                                alertDescription={formik.errors.email}
                            />
                        )}
                    </Stack>
                    {serverResponse?.message?.length > 0 && (
                        <GrubErrorMessage
                            errorMessage={serverResponse?.message}
                            isError={serverResponse?.error}
                            width={"auto"}
                        />
                    )}
                    <Box mt={{ base: "2.44rem", md: "2.44rem" }}>
                        <GrubFormButton
                            isDisabled={loading}
                            width={"18.6rem"}
                            bg={Colors.posTextInfo}
                            buttonsubmit={"Forgot Password"}
                            onClick={(e) => {
                                e.preventDefault();
                                formik.handleSubmit();
                            }}
                        />
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default WithRouter(ForgotPassword);
